<template>
  <div class="moretwocontents">
      <div class="moretwo">
        <div class="title">多种接口，兼容更多</div>
        <div class="write">维码器适用于各种自助投币设备，兼容性强</div>
        <div class="port">
            <div class="port-middle" ref="middle" :style="mid">
                <div class="middle-left">
                    <div class="four">
                        <div class="four-lines"><div class="four-cir cir">④</div><div class="four-line"></div></div>
                        <div class="word">退奖信号4P输入接口</div>
                    </div>
                    <div class="nine">
                        <div class="nine-line"></div>
                        <div class="nine-item">
                            <div class="nine-cir cir">⑨</div>
                            <div class="word">液晶屏排线</div>
                        </div>
                    </div>
                    <div class="five">
                        <div class="nine-line"></div>
                        <div class="nine-item">
                            <div class="nine-cir cir">⑤</div>
                            <div class="word">内部专用</div>
                        </div>
                    </div>
                </div>
                <div class="middle-right">
                    <div class="one">
                        <div class="one-line"></div>
                        <div class="one-item">
                            <div class="word">脉冲信号4P输入接口</div>
                            <div class="one-cir cir">①</div>
                        </div>
                    </div>
                    <div class="two">
                        <div class="two-line"></div>
                        <div class="two-item">
                            <div class="word">脉冲信号4P输入接口</div>
                            <div class="two-cir cir">②</div>
                        </div>
                    </div>
                    <div class="three">
                        <div class="three-line"></div>
                        <div class="three-item">
                            <div class="word">串口接口</div>
                            <div class="three-cir cir">③</div>
                        </div>
                    </div>
                    <div class="eight">
                        <div class="eight-line"></div>
                        <div class="eight-item">
                            <div class="word">状态灯<br/>快闪：正在连接网络<br/>常亮：已连接网络</div>
                            <div class="eight-cir cir">⑧</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="port-list" ref="port">
                <img src="./images/phone/product_Inter1.png" alt="投币器接口">
            </div> 
            <div class="port-bottom">
                <div class="seven">
                    <div class="seven-cir cir">⑦</div>
                    <div class="line"></div>
                    <div class="word">WIFI天线</div>
                </div>
                <div class="seven">
                    <div class="seven-cir cir">⑥</div>
                    <div class="line"></div>
                    <div class="word">GPRS天线</div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'moretwo',
  data(){
      return{
      }
  },
  mounted(){
      var c = this.$refs.port.offsetHeight;
      var middle = this.$refs.middle.offsetHeight;
      this.mid.height = c;
  }
}
</script>

<style scoped>
.moretwocontents{
    width:100%;
    background-color: #fafafa;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.moretwo{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
 .moretwo .title{
font-size: 22px;
letter-spacing: 0.5px;
color: #000000;
margin-top: 50px;
}
.moretwo .write{
font-size: 10.5px;
line-height: 0px;
color: #000000;
margin-top:12.5px;
}
.moretwo .port{
margin:48px 0px;
display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
}
.moretwo .port .port-list,.port-bottom{
    width: 80vw;
}
.moretwo .port .port-list img{
    width: 100%;
}
.port-bottom{
    width: 80vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.port-middle{
    /* width: 70%; */
    width: 70vw;
    height: 65vw;
        display: flex;
    justify-content: space-around;
    align-items: center;
        position: absolute;
    top: 5%;
    left:5%;
}
.middle-left,.middle-right{
    width: 47%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.middle-left{
    padding-left: 2.5vw;
}
.middle-right{
    padding-right: 2.5vw;
}
.seven{
    width: 27%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.cir{
    width: 15px;
    height: 15px;
    color: #198bfe;
    font-size: 13px;  /*为什么手机上是要17px才能居中 */
    text-align: center;
}
.nine-cir{
    margin-right: 10px;
    box-sizing: border-box;
}
.four{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.four-lines{
    height: 22px;
        display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
}
.line{
    width: 1px;
    height: 11px;
    background: #198bfe;
}
.four-line{
    width: 15px;
    height: 15px;
    border-top: 1px solid #198bfe;
    border-right: 1px solid #198bfe;
    position: absolute;
    left: 17px;
    top: 7px;
}
.word{
    font-size: 9px;
}

.nine-line{
    width: 30px;
    height: 16px;
    border-top: 1px solid #198bfe;
    border-right: 1px solid #198bfe;
    border-left: 1px solid #198bfe;
        margin-left: 10px;
}
.nine-item{
        display: flex;
        justify-content: flex-start;
    align-items: center;
}
.one-line,.two-line,.three-line{
    width: 44px;
    height: 10px;
     border-top: 1px solid #198bfe;
    border-left: 1px solid #198bfe;
    border-right: 1px solid #198bfe;
        margin-right: 9px;
}
.eight-line{
    width: 20px;
	height: 52px;
	border-top: solid 1px #1a8bff;
    border-bottom: solid 1px #1a8bff;
    border-left: 1px solid #198bfe;
    margin-bottom: 6px;
}
.eight{
    display: flex;
        justify-content: center;
    align-items: flex-end;
}
.eight-item{
    display: flex;
    flex-direction: column;
    
}
.one-item,.two-item{
    display: flex;
}
.three-item{
    width: 25vw;
    display: flex;
    justify-content: space-between;
}
.one,.two,.three{
        display: flex;
    flex-direction: column;
    align-items: flex-end;
}

</style>




// WEBPACK FOOTER //
// src/components/hardProduct/moretwo.vue